import { GetAlertsParams } from '@/modules/adjusterReportModules/adjusterReport/queries/getAlerts/getAlertsQuery.type';
import { getAlertsQueryFunctions } from '@/modules/adjusterReportModules/adjusterReport/queries/getAlerts/getAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getAlertsQueryOptions = (params: GetAlertsParams) =>
  queryOptions({
    queryKey: ['getAlerts', params],
    queryFn: () => getAlertsQueryFunctions(params),
  });
export default getAlertsQueryOptions;
